import { Injectable, Renderer2, RendererFactory2, Inject, DOCUMENT } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class CustomDomService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  getDivHeightById(id: string): number | null {
    const element = this.document.getElementById(id);
    if (element) {
      return element.offsetHeight;
    }
    return null;
  }
}